import React from "react"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretRight } from "@fortawesome/free-solid-svg-icons"

const StyledProject = styled.div`
  margin-top: 25px;
  margin-bottom: 5px;
`

const ProjectText = styled.div`
  text-align: left;
`

const Title = styled.div`
  color: var(--prussian-blue);
  font-weight: bold;

`

const StyledPoint = styled.div`
  display: grid;
  grid-template-columns: 20px auto;
  margin-top: 5px;
`

const BulletContainer = styled.div`
  text-align: right;
  padding-right: 5px;
`

const PointBullet = styled(FontAwesomeIcon)``

const Point = ({text}: {text: String}) => {
  return (
    <StyledPoint>
      <BulletContainer>
        <PointBullet icon={faCaretRight} />
      </BulletContainer>
      <div>{text}</div>
    </StyledPoint>
  )
}

type Props = {
  name: string
  points: string[]
  relatedtech?: JSX.Element
}

const Project = ({name, points, relatedtech}: Props) => {
  return (
    <StyledProject>
      <ProjectText>
        <Title>{name}</Title>
        {points.map(p => <Point text={p} key={p}/>)}
      </ProjectText>
      {relatedtech}
    </StyledProject>
  )
}

export default Project